import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) {
      setState("unknown");
      return;
    }
    let attempts = 0;
    const timer = setInterval(async () => {
      attempts += 1;
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          clearInterval(timer);
        } else if (attempts >= 8) {
          setState("pending");
          clearInterval(timer);
        }
      } catch {
        if (attempts >= 8) {
          setState("unknown");
          clearInterval(timer);
        }
      }
    }, 2000);
    return () => clearInterval(timer);
  }, [sessionId]);

  return (
    <main data-testid="payment-success-page" className="flex min-h-screen items-center justify-center bg-[#050505] px-6">
      <div className="glow-border max-w-lg p-10 text-center sm:p-14">
        <p className="text-[11px] uppercase tracking-[0.4em] gold-text ff-sans">Pleasure • Presence • Connection</p>
        <h1 className="mt-6 ff-serif text-5xl font-light italic gold-text sm:text-6xl">
          {state === "paid" ? "The Portal is open." : state === "checking" ? "Confirming…" : "Almost there."}
        </h1>
        <p data-testid="payment-success-status" className="mt-6 text-sm font-light leading-relaxed text-[#f7e7ce]/70 ff-sans">
          {state === "paid" &&
            "Your order is confirmed. You'll receive a receipt by email, and your ritual ships discreetly."}
          {state === "checking" && "We're confirming your payment with our secure checkout. One moment."}
          {state === "pending" &&
            "Your payment is being processed. You'll receive an email confirmation shortly."}
          {state === "unknown" &&
            "We couldn't verify this session, but if you completed checkout your confirmation email is on its way."}
        </p>
        <Link
          data-testid="payment-success-home-link"
          to="/"
          className="btn-outline-gold mt-8 inline-block px-8 py-4 text-xs font-semibold uppercase tracking-[0.25em] ff-sans"
        >
          Return to the Portal
        </Link>
      </div>
    </main>
  );
}

export function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="flex min-h-screen items-center justify-center bg-[#050505] px-6">
      <div className="max-w-lg border hairline-champagne p-10 text-center sm:p-14">
        <h1 className="ff-serif text-4xl font-light text-[#fdfbf7] sm:text-5xl">
          The Portal <span className="italic gold-text">will wait.</span>
        </h1>
        <p className="mt-6 text-sm font-light leading-relaxed text-[#f7e7ce]/70 ff-sans">
          Your checkout was cancelled — nothing was charged. Whenever you're ready, the ritual is here.
        </p>
        <Link
          data-testid="payment-cancel-home-link"
          to="/#offer"
          className="btn-gold mt-8 inline-block px-8 py-4 text-xs font-semibold uppercase tracking-[0.25em] ff-sans"
        >
          Back to the Offers
        </Link>
      </div>
    </main>
  );
}
